import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';

import Select from 'react-select';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementHeader from './SidebarElementHeader.js';
import Slider, { Range } from 'rc-slider';
import AlignPicker from './AlignPicker.js';

class Socialfollow extends React.Component {
	constructor(props) {	
		super(props);
		
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.available = ['web','facebook','instagram','googleplus','twitter','tumblr','linkedin'];
		this.renderIcons = this.renderIcons.bind(this);
		this.onPaddingBottomChange = this.onPaddingBottomChange.bind(this);
		this.onPaddingTopChange = this.onPaddingTopChange.bind(this);
		this.renderLabel = this.renderLabel.bind(this);
		this.renderLinks = this.renderLinks.bind(this);
		this.onPaddingChange = this.onPaddingChange.bind(this);
		this.setActive = this.setActive.bind(this);
		this.handleLinkChange = this.handleLinkChange.bind(this);

		this.options = [
            { value: '1',clearableValue:false, label: this.renderLabel(1) },
            { value: '2',clearableValue:false, label: this.renderLabel(2) }
        ];
	}

	setActive(e) {
		this.props.setComponentState(this.el().id,{[e.target.id]:!this.el()[e.target.id]});
	}

	handleLinkChange(e) {
        this.props.setComponentState(this.el().id,{
        	[e.target.getAttribute('data-id')]:e.target.value
        });
	}

	renderLinks() {
		let links = [];

		for(let i in this.available) {
			links.push(
				<div className="form-group" key={i} >
                  <div className="input-group input-group-icon">
                    <span className="input-group-addon">
                   	<div style={{display:'inline-block',marginRight: '10px'}} className="checkbox-custom checkbox-primary">
	                  <input type="checkbox" id={this.available[i]+'_active'} onChange={this.setActive} checked={this.el()[this.available[i]+'_active']} />
	                  <label htmlFor={this.available[i]+'_active'}></label>
	                </div>
                      <img style={{width:'15px'}} src={`/images/marketing/brands/${this.el().type}/${this.available[i]}.png`} />
                    </span>
                    <input type="text" data-id={this.available[i]} onChange={this.handleLinkChange} value={this.el()[this.available[i]]} className="form-control" placeholder='https://' />
                  </div>
                </div>
			);	
		}

		return links;
	}

	renderLabel(id) {
		let icons = [];

		for(let i in this.available) {
			icons.push(<img style={{marginRight:'20px',width:'15px'}} key={i} src={`/images/marketing/brands/${id}/${this.available[i]}.png`} />);	
		}

		return <div>{icons}</div>;
	}

	renderIcons() {
		let icons = [];

		for(let i in this.available) {
			if(this.el()[this.available[i]+'_active'] == true) {
				icons.push(<a href='#' key={i} style={{paddingRight:'10px'}}><img style={{width:'30px'}} src={`/images/marketing/brands/${this.el().type}/${this.available[i]}.png`} /></a>);	
			}
		}


		return icons;
	}


    el() {
    	return this.props.builder.components[this.props.id];
    }

    renderSettings() {
    	return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{type:v.value});
    }

    onPaddingTopChange(v) {
    	this.props.setComponentState(this.el().id,{paddingTop:v+'px'});
    }

    onPaddingBottomChange(v) {
    	this.props.setComponentState(this.el().id,{paddingBottom:v+'px'});
    }

    onPaddingChange(id,padding) {
        let changes = {};
        changes[id] = padding;      
        this.props.setComponentState(this.el().id,changes);
    }

    render() {
    	

    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Spacing" />
	    			
	    			<div className="panel-group panel-group-continuous" id="Socialfollow-settings" aria-multiselectable="true" role="tablist">

	    				<SidebarSettingAccordion selectedSetting={false} optionKey="icontypes" parent="Socialfollow-settings" title="Icon">
	    					<SidebarElementSetting text="Icon types">
				    			<Select
			                        allowCreate={false}
			                        searchable={false}
			                        clearable={false}
			                        name="form-field-name"
			                        value={this.el().type}
			                        options={this.options}
			                        onChange={this.onChange}
			                    />
							</SidebarElementSetting>

							<SidebarElementSetting text="Icon links">
				    			{this.renderLinks()}
							</SidebarElementSetting>
						</SidebarSettingAccordion>

						<SidebarSettingAccordion selectedSetting={false} optionKey="spacing" parent="Socialfollow-settings" title="Spacing">

							<SidebarElementSetting text="Horizontal position">
				                    <AlignPicker id="align" align={this.el().align} handleChange={this.onPaddingChange}/>
				                </SidebarElementSetting>


							<SidebarElementSetting text="Spacing top">
							
								<Slider
								value={parseInt(this.el().paddingTop.replace('px',''))}
								onChange={this.onPaddingTopChange} 

									min={5}
									max={100}
								/>
							</SidebarElementSetting>

							<SidebarElementSetting text="Spacing bottom">
								<Slider
								value={parseInt(this.el().paddingBottom.replace('px',''))}
								onChange={this.onPaddingBottomChange} 
									min={5}
									max={100}
								/>
							</SidebarElementSetting>


						</SidebarSettingAccordion>
					</div>
 
	    		</div>
    		);
    	}else{
    		return (
	      		<table className="table-block" style={{width:'100%'}}>
    				<tbody>
    					<tr>
	    					<td style={{textAlign:this.el().align,paddingTop:this.el().paddingTop,paddingBottom:this.el().paddingBottom}}>
	    						{this.renderIcons()}
	    					</td>
    					</tr>
    				</tbody>
    			</table>
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Socialfollow = connect(mapStateToProps,mapDispatchToProps)(Socialfollow);

export default Socialfollow;





// WEBPACK FOOTER //
// ./components/builder/Socialfollow.js